<template>
  <div class="calico-drawer-page">
    <CaclicoDrawer :show="show">
      <img :src="imageSrc">
    </CaclicoDrawer>
    <div
      class="content"
      @click="onShow"
    >
      Content aln djasknd jkasnd jkasnd jkasdkjasnd jkasndkj sandkj sandksakdj nsakjdnaskj dnaksjdn ajkdn aksjdnkajs
    </div>
  </div>
</template>

<script lang="js">
import CaclicoDrawer from "@/components/calico/drawer/index.vue"
import imageSrc from "@/assets/bd4541986f91012fc53b9029a6935847.jpeg"

export default {
  name: 'CalicoDrawerPage',
  components: {
    CaclicoDrawer,
  },
  data () {
    return {
      show: false,
      imageSrc
    }
  },
  methods: {
    onShow() {
      this.show = !this.show
    }
  }
}
</script>

<style lang="scss">
.calico-drawer-page {
  display: flex;
  img {
    width: 250px;
    height: 100px;
  }
  .content {
    height: 100vh;
    width: 100%;
    background: rgb(119, 113, 113);
  }
}
</style>
